
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models'
export type * from './prismaNamespace'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  Ad: 'Ad',
  Tool: 'Tool',
  ToolRepository: 'ToolRepository',
  Repository: 'Repository',
  CatalogFieldEvidence: 'CatalogFieldEvidence',
  RepositoryReview: 'RepositoryReview',
  Category: 'Category',
  Tag: 'Tag',
  Report: 'Report',
  BrandMention: 'BrandMention',
  NewsletterSubscription: 'NewsletterSubscription',
  AlternativePage: 'AlternativePage',
  Alternative: 'Alternative',
  Bookmark: 'Bookmark',
  Post: 'Post'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const AdScalarFieldEnum = {
  id: 'id',
  email: 'email',
  name: 'name',
  description: 'description',
  websiteUrl: 'websiteUrl',
  faviconUrl: 'faviconUrl',
  bannerUrl: 'bannerUrl',
  buttonLabel: 'buttonLabel',
  type: 'type',
  startsAt: 'startsAt',
  endsAt: 'endsAt',
  sessionId: 'sessionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AdScalarFieldEnum = (typeof AdScalarFieldEnum)[keyof typeof AdScalarFieldEnum]


export const ToolScalarFieldEnum = {
  lifecycleStatus: 'lifecycleStatus',
  primaryTask: 'primaryTask',
  accessModels: 'accessModels',
  entityType: 'entityType',
  taskCodes: 'taskCodes',
  deliveryModels: 'deliveryModels',
  capabilities: 'capabilities',
  taxonomyConfidence: 'taxonomyConfidence',
  classificationEvidenceUrl: 'classificationEvidenceUrl',
  classificationReviewedAt: 'classificationReviewedAt',
  parentProductId: 'parentProductId',
  tier: 'tier',
  tierPriority: 'tierPriority',
  id: 'id',
  name: 'name',
  slug: 'slug',
  websiteUrl: 'websiteUrl',
  affiliateUrl: 'affiliateUrl',
  tagline: 'tagline',
  description: 'description',
  content: 'content',
  faviconUrl: 'faviconUrl',
  screenshotUrl: 'screenshotUrl',
  lastVerifiedAt: 'lastVerifiedAt',
  verificationSourceUrl: 'verificationSourceUrl',
  verificationNote: 'verificationNote',
  isFeatured: 'isFeatured',
  isOpenSource: 'isOpenSource',
  starsTotal: 'starsTotal',
  clickCount: 'clickCount',
  languages: 'languages',
  features: 'features',
  submitterName: 'submitterName',
  submitterEmail: 'submitterEmail',
  submitterNote: 'submitterNote',
  status: 'status',
  publishedAt: 'publishedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ownerId: 'ownerId'
} as const

export type ToolScalarFieldEnum = (typeof ToolScalarFieldEnum)[keyof typeof ToolScalarFieldEnum]


export const ToolRepositoryScalarFieldEnum = {
  id: 'id',
  toolId: 'toolId',
  repositoryId: 'repositoryId',
  repoRole: 'repoRole',
  roleEvidenceUrl: 'roleEvidenceUrl',
  officialOwnerVerified: 'officialOwnerVerified',
  qualificationState: 'qualificationState',
  recommendedAction: 'recommendedAction',
  qualificationReasons: 'qualificationReasons',
  qualifiedAt: 'qualifiedAt',
  url: 'url',
  fullName: 'fullName',
  stars: 'stars',
  forks: 'forks',
  language: 'language',
  license: 'license',
  isArchived: 'isArchived',
  pushedAt: 'pushedAt',
  packageName: 'packageName',
  packageRegistry: 'packageRegistry',
  monthlyDownloads: 'monthlyDownloads',
  readme: 'readme',
  docsUrl: 'docsUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ToolRepositoryScalarFieldEnum = (typeof ToolRepositoryScalarFieldEnum)[keyof typeof ToolRepositoryScalarFieldEnum]


export const RepositoryScalarFieldEnum = {
  defaultBranch: 'defaultBranch',
  licenseCheckedAt: 'licenseCheckedAt',
  licenseFileSha: 'licenseFileSha',
  lastRevalidationAt: 'lastRevalidationAt',
  revalidationStatus: 'revalidationStatus',
  id: 'id',
  canonicalUrl: 'canonicalUrl',
  fullName: 'fullName',
  githubId: 'githubId',
  stars: 'stars',
  forks: 'forks',
  language: 'language',
  license: 'license',
  licenseExpression: 'licenseExpression',
  licenseSource: 'licenseSource',
  licenseEvidenceUrl: 'licenseEvidenceUrl',
  requiresLicenseReview: 'requiresLicenseReview',
  isArchived: 'isArchived',
  isFork: 'isFork',
  pushedAt: 'pushedAt',
  lastCommitAt: 'lastCommitAt',
  lastCommitSha: 'lastCommitSha',
  metricsRecordedAt: 'metricsRecordedAt',
  metricsSourceUrl: 'metricsSourceUrl',
  metadataCheckedAt: 'metadataCheckedAt',
  nextReviewAt: 'nextReviewAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RepositoryScalarFieldEnum = (typeof RepositoryScalarFieldEnum)[keyof typeof RepositoryScalarFieldEnum]


export const CatalogFieldEvidenceScalarFieldEnum = {
  id: 'id',
  toolId: 'toolId',
  repositoryId: 'repositoryId',
  field: 'field',
  value: 'value',
  sourceKind: 'sourceKind',
  sourceUrl: 'sourceUrl',
  addedVia: 'addedVia',
  snapshotId: 'snapshotId',
  fetchedAt: 'fetchedAt',
  verifiedAt: 'verifiedAt',
  verifiedBy: 'verifiedBy',
  confidence: 'confidence',
  capabilityLevel: 'capabilityLevel',
  createdAt: 'createdAt'
} as const

export type CatalogFieldEvidenceScalarFieldEnum = (typeof CatalogFieldEvidenceScalarFieldEnum)[keyof typeof CatalogFieldEvidenceScalarFieldEnum]


export const RepositoryReviewScalarFieldEnum = {
  id: 'id',
  toolRepositoryId: 'toolRepositoryId',
  previousState: 'previousState',
  nextState: 'nextState',
  action: 'action',
  reasons: 'reasons',
  evidenceUrls: 'evidenceUrls',
  reviewer: 'reviewer',
  createdAt: 'createdAt'
} as const

export type RepositoryReviewScalarFieldEnum = (typeof RepositoryReviewScalarFieldEnum)[keyof typeof RepositoryReviewScalarFieldEnum]


export const CategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  label: 'label',
  description: 'description',
  parentCategoryId: 'parentCategoryId',
  depth: 'depth',
  order: 'order',
  fullPath: 'fullPath',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CategoryScalarFieldEnum = (typeof CategoryScalarFieldEnum)[keyof typeof CategoryScalarFieldEnum]


export const TagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  group: 'group',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt'
} as const

export type TagScalarFieldEnum = (typeof TagScalarFieldEnum)[keyof typeof TagScalarFieldEnum]


export const ReportScalarFieldEnum = {
  id: 'id',
  type: 'type',
  message: 'message',
  email: 'email',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  toolId: 'toolId'
} as const

export type ReportScalarFieldEnum = (typeof ReportScalarFieldEnum)[keyof typeof ReportScalarFieldEnum]


export const BrandMentionScalarFieldEnum = {
  id: 'id',
  sourceTitle: 'sourceTitle',
  sourceUrl: 'sourceUrl',
  platform: 'platform',
  status: 'status',
  sentiment: 'sentiment',
  isLinked: 'isLinked',
  observedAt: 'observedAt',
  owner: 'owner',
  notes: 'notes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BrandMentionScalarFieldEnum = (typeof BrandMentionScalarFieldEnum)[keyof typeof BrandMentionScalarFieldEnum]


export const NewsletterSubscriptionScalarFieldEnum = {
  id: 'id',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  status: 'status',
  tokenHash: 'tokenHash',
  consentText: 'consentText',
  consentVersion: 'consentVersion',
  consentSource: 'consentSource',
  requestIpAddress: 'requestIpAddress',
  requestUserAgent: 'requestUserAgent',
  confirmedIpAddress: 'confirmedIpAddress',
  confirmedUserAgent: 'confirmedUserAgent',
  requestedAt: 'requestedAt',
  confirmedAt: 'confirmedAt',
  expiresAt: 'expiresAt',
  lastEmailSentAt: 'lastEmailSentAt',
  resendContactId: 'resendContactId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type NewsletterSubscriptionScalarFieldEnum = (typeof NewsletterSubscriptionScalarFieldEnum)[keyof typeof NewsletterSubscriptionScalarFieldEnum]


export const AlternativePageScalarFieldEnum = {
  id: 'id',
  sourceToolId: 'sourceToolId',
  title: 'title',
  description: 'description',
  summary: 'summary',
  pricingContrast: 'pricingContrast',
  licenseContrast: 'licenseContrast',
  featureContrast: 'featureContrast',
  sourceNotes: 'sourceNotes',
  demandEvidence: 'demandEvidence',
  stayWithSource: 'stayWithSource',
  reasonCodes: 'reasonCodes',
  lastVerifiedAt: 'lastVerifiedAt',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AlternativePageScalarFieldEnum = (typeof AlternativePageScalarFieldEnum)[keyof typeof AlternativePageScalarFieldEnum]


export const AlternativeScalarFieldEnum = {
  id: 'id',
  pageId: 'pageId',
  toolId: 'toolId',
  bestFor: 'bestFor',
  pricingNote: 'pricingNote',
  licenseNote: 'licenseNote',
  featureNote: 'featureNote',
  tradeoff: 'tradeoff',
  vendorNote: 'vendorNote',
  reasonCodes: 'reasonCodes',
  order: 'order',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AlternativeScalarFieldEnum = (typeof AlternativeScalarFieldEnum)[keyof typeof AlternativeScalarFieldEnum]


export const BookmarkScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  toolId: 'toolId'
} as const

export type BookmarkScalarFieldEnum = (typeof BookmarkScalarFieldEnum)[keyof typeof BookmarkScalarFieldEnum]


export const PostScalarFieldEnum = {
  id: 'id',
  title: 'title',
  slug: 'slug',
  description: 'description',
  content: 'content',
  plainText: 'plainText',
  imageUrl: 'imageUrl',
  status: 'status',
  publishedAt: 'publishedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  authorId: 'authorId'
} as const

export type PostScalarFieldEnum = (typeof PostScalarFieldEnum)[keyof typeof PostScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const JsonNullValueInput = {
  JsonNull: JsonNull
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]

